import initialStore from '../initialStore';
import { AuthStore } from '../../types/auth';
import { AuthAction } from '../../types/actions';

export const viewersReducer = (currentState: AuthStore, action: AuthAction) => {
  switch (action.type) {
  case 'GET_VIEWER_REQUEST':
    return Object.assign({}, currentState, {
      loading: true,
      data: [],
      error: null
    });
  case 'GET_VIEWER_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      data: action
    });
  case 'GET_VIEWER_ERROR':
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error
    });
  default:
    return currentState || initialStore.resources;
  }
};

export const shareReducer = (currentState: AuthStore, action: AuthAction) => {
  switch (action.type) {
  case 'GET_SHARE_REQUEST':
    return Object.assign({}, currentState, {
      loading: true,
      data: [],
      error: null
    });
  case 'GET_SHARE_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      data: action.info
    });
  case 'GET_SHARE_ERROR':
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error
    });
  default:
    return currentState || initialStore.shared;
  }
};


export const sharedResourcesReducer = (currentState: AuthStore, action: AuthAction) => {
  switch (action.type) {
  case 'GET_SHARED_RESOURCES_REQUEST':
    return Object.assign({}, currentState, {
      loading: true,
      data: [],
      error: null
    });
  case 'GET_SHARED_RESOURCES_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      data: action.resources
    });
  case 'GET_SHARED_RESOURCES_ERROR':
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error
    });
  default:
    return currentState || initialStore.sharedResources;
  }
};


export const singleSharedResourceReducer = (currentState: AuthStore, action: AuthAction) => {
  switch (action.type) {
  case 'GET_SHARED_SINGLE_RESOURCE_REQUEST':
    return Object.assign({}, currentState, {
      loading: true,
      data: [],
      error: null
    });
  case 'GET_SHARED_SINGLE_RESOURCE_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      data: action.resource
    });
  case 'GET_SHARED_SINGLE_RESOURCE_ERROR':
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error
    });
  default:
    return currentState || initialStore.sharedResource;
  }
};

export const getSharedFileReducer = (currentState: AuthStore, action: AuthAction) => {
  switch (action.type) {
  case 'GET_SHARED_FILE_REQUEST':
    return Object.assign({}, currentState, {
      loading: true,
      data: [],
      error: null
    });
  case 'GET_SHARED_FILE_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      data: action.file
    });
  case 'GET_SHARED_FILE_ERROR':
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error
    });
  default:
    return currentState || initialStore.sharedFileInfo;
  }
};

export const getSharedThumbReducer = (currentState: AuthStore, action: AuthAction) => {
  switch (action.type) {
  case 'GET_SHARED_THUMB_REQUEST':
    return Object.assign({}, currentState, {
      loading: true,
      data: [],
      error: null
    });
  case 'GET_SHARED_THUMB_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      data: action.file
    });
  case 'GET_SHARED_THUMB_ERROR':
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error
    });
  default:
    return currentState || initialStore.sharedFileThumb;
  }
};

export const viewSharedFileReducer = (currentState: AuthStore, action: AuthAction) => {
  switch (action.type) {
  case 'VIEW_SHARED_FILE_REQUEST':
    return Object.assign({}, currentState, {
      loading: true,
      data: [],
      error: null
    });
  case 'VIEW_SHARED_FILE_SUCCESS':
    return Object.assign({}, currentState, {
      loading: false,
      data: action.file
    });
  case 'VIEW_SHARED_FILE_ERROR':
    return Object.assign({}, currentState, {
      loading: false,
      error: action.error
    });
  default:
    return currentState || initialStore.sharedFileView;
  }
};

export const getToken = (currentState: AuthStore, action: AuthAction) => {
  switch (action.type) {
  case 'GET_SHARE_TOKEN':
    return Object.assign({}, currentState, {
      data: action.token
    });
  default:
    return currentState || initialStore.sharedToken;
  }
};

export const getAccessToken = (currentState: AuthStore, action: AuthAction) => {
  switch (action.type) {
  case 'GET_SHARE_ACCESSTOKEN':
    return Object.assign({}, currentState, {
      data: action.token
    });
  default:
    return currentState || initialStore.sharedAccessToken;
  }
};


export default shareReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/shared.js